/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull checkout-hosted'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 168
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/implementation/checkout-hosted)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'be237974d6ba66e5ed3bbf56ac4b6e48',
  development: '000e3bbcc2c10d22df926468ee9aef91'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '168',
    branch: 'main',
    source: 'checkout-hosted',
    versionId: '6c9f59d1-26b3-4926-a2f0-d7d68292d669'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * User's App Locale
   */
  "App Language"?: string;
  /**
   * Users App Theme (Dark/Light)
   */
  "App Theme"?: string;
  /**
   * Country registered based on the phone number characteristic
   */
  "Country Entered"?: any;
  /**
   * It shows where was created the account (if it was in OT or in the Apps)
   */
  "Created With"?: any;
  "Email Status"?: any;
  "Has card"?: string;
  /**
   * If the user created the account in the Apps will have a password, if it was through OT it won't
   */
  "Has Password"?: any;
  "KYC Status"?: any;
  "Percentage Tasks Completed"?: any;
  /**
   * Show in which product is triggered the event
   */
  "Product Type"?: any;
  "Qty Deposits Completed"?: any;
  "Qty Links Created"?: any;
  "Qty Purchases Completed"?: any;
  "Qty Purchases Created"?: any;
  "Qty Purchases Transactions"?: any;
  "Qty Transactions"?: any;
  "Qty Withdrawals Completed"?: any;
  "Qty Withdrawals Created"?: any;
  "Qty Withdrawals Rejected"?: any;
}

export interface DownloadAstroPayLandingImpressionProperties {
  payment_external_id?: string;
}

export interface DownloadAstroPayLinkCopiedProperties {
  payment_external_id?: string;
}

export interface HostedCheckoutImpressionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  merchant_name?: string;
  payment_external_id?: string;
}

export interface HostedCheckoutPaymentCancelClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  merchant_name?: string;
  payment_external_id?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DownloadAstroPayLandingImpression implements BaseEvent {
  event_type = 'Download AstroPay Landing Impression';

  constructor(
    public event_properties?: DownloadAstroPayLandingImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DownloadAstroPayLinkCopied implements BaseEvent {
  event_type = 'Download AstroPay Link Copied';

  constructor(
    public event_properties?: DownloadAstroPayLinkCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HostedCheckoutImpression implements BaseEvent {
  event_type = 'Hosted Checkout Impression';

  constructor(
    public event_properties?: HostedCheckoutImpressionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HostedCheckoutPaymentCancelClicked implements BaseEvent {
  event_type = 'Hosted Checkout Payment Cancel Clicked';

  constructor(
    public event_properties?: HostedCheckoutPaymentCancelClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Download AstroPay Landing Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/events/main/latest/Download%20AstroPay%20Landing%20Impression)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. payment_external_id)
   * @param options Amplitude event options.
   */
  downloadAstroPayLandingImpression(
    properties?: DownloadAstroPayLandingImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new DownloadAstroPayLandingImpression(properties), options);
  }

  /**
   * Download AstroPay Link Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/events/main/latest/Download%20AstroPay%20Link%20Copied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. payment_external_id)
   * @param options Amplitude event options.
   */
  downloadAstroPayLinkCopied(
    properties?: DownloadAstroPayLinkCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DownloadAstroPayLinkCopied(properties), options);
  }

  /**
   * Hosted Checkout Impression
   *
   * [View in Tracking Plan](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/events/main/latest/Hosted%20Checkout%20Impression)
   *
   * When the user open the hosted checkout
   *
   * @param properties The event's properties (e.g. merchant_name)
   * @param options Amplitude event options.
   */
  hostedCheckoutImpression(
    properties?: HostedCheckoutImpressionProperties,
    options?: EventOptions,
  ) {
    return this.track(new HostedCheckoutImpression(properties), options);
  }

  /**
   * Hosted Checkout Payment Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/astropay/AstroPay%20-%20PROD/events/main/latest/Hosted%20Checkout%20Payment%20Cancel%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchant_name)
   * @param options Amplitude event options.
   */
  hostedCheckoutPaymentCancelClicked(
    properties?: HostedCheckoutPaymentCancelClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HostedCheckoutPaymentCancelClicked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
